const Button = {
  baseStyle: {
    fontWeight: 600,
  },
  sizes: {
    sm: {
      borderRadius: '6px',
      fontSize: '14px',
      h: {
        base: '32px',
      },
      padding: '7px 12px',
    },
    md: {
      borderRadius: '6px',
      fontSize: '14px',
      h: {
        base: '40px',
      },
      padding: '7px 12px',
    },
  },
  variants: {
    solid: {
      bgColor: 'secondary',
      color: '#fff',
      cursor: 'pointer',
      textAlign: 'center',
      _disabled: {
        bgColor: '#545455',
        color: '#C3C3C3',
      },
      _hover: {
        bgColor: '#131415',
      },
      _active: {
        bgColor: '#131415',
      },
    },
    outline: {
      borderColor: 'primary',
      color: 'primary',
    },
    clean: {
      p: 0,
      h: 'auto',
      borderRadius: 0,
      minW: '0',
    },
    icon: {
      minW: '0',
      w: '20px',
      h: '20px',
      borderRadius: '30px',
      p: '10px',
      _hover: {
        bgColor: '#e3f4ff',
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'solid',
  },
}

export default Button
